import React, { useState, useEffect } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import Page404 from '../page404';
// import { Header, Footer, LeftMenu } from "../commons/components";
// import { Content } from "./components";
import Mainhome from './home';
import DetailTheme from './Detail';
import AddTheme from './Add';
import EditTheme from './Edit';
import { getAllEmployees } from './actions';
import { isAuth } from '../auth/actions';
import { Redirect } from 'react-router';


export default function Home() {
  const { path } = useRouteMatch();
  const [employees, setEmployees] = useState([]);

  useEffect(() => {
    loadEmployees();
  }, []);
  // console.log( path , '13_path...')

  const loadEmployees = () => {
    getAllEmployees().then((data) => {
      if (data.error) {
        console.log(data.error);
      } else {
        console.log('All Employees', data);
        setEmployees(data);
      }
    });
  };

  return (
    <React.Fragment>
     {isAuth() ? (
      <Switch>
        <Route exact path={path}>
          <Mainhome employees={employees} />
        </Route>
        <Route path={`${path}/add`}>
          <AddTheme />
        </Route>
        <Route path={`${path}/edit/:id`}>
          <EditTheme />
        </Route>
        <Route path={`${path}/detail/:id`}>
          <DetailTheme employees={employees} />
        </Route>
        <Route path={`${path}/*`}>
          <Page404 />
        </Route>
      </Switch>
       ) : (
          <Redirect to='/auth' />
      )}
    </React.Fragment>
  );
}
